import axios from "axios";
import { useEffect } from "react";
import { MemoryRouter, BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from './components/Dashboard';
import GlobalSnackbar from "./components/GlobalSnackbar";
import ExtensionHomePage from "./components/ExtensionHomePage";
import Loading from "./components/Loading";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import { checkIfLoggedIn } from "./controllers/auth";
import { useDispatchContext, useStateContext } from "./Store/Context";
import WebHomePage from "./components/WebHomePage";
import { ISetMediumAction } from "./types";
import { ActionType } from "./constants";
import SharedLinks from "./components/WebPageComponents/SharedLinks";

axios.defaults.withCredentials = true;

function App() {
	const { isLoggedIn, loading, medium } = useStateContext();
	const dispatch = useDispatchContext();

	useEffect(() => {
		checkIfLoggedIn(dispatch);

		if (document.location.origin.startsWith("chrome-extension")) {
			const action: ISetMediumAction = {
				type: ActionType.SET_MEDIUM,
				payload: {
					type: 'extension'
				}
			}

			dispatch(action);
		} else {
			const action: ISetMediumAction = {
				type: ActionType.SET_MEDIUM,
				payload: {
					type: 'web'
				}
			}

			dispatch(action);
		}
	}, [dispatch]);

	if (medium === 'web') {
		return (
			<>
				<BrowserRouter>
					<Routes>
						<Route path="/" element={isLoggedIn ? <Dashboard /> : loading ? <Loading /> : <WebHomePage />} />
						<Route path="/signin" element={loading ? <Loading /> : isLoggedIn ? <Navigate to={"/"} /> : <SignIn />} />
						<Route path="/signup" element={loading ? <Loading /> : isLoggedIn ? <Navigate to={"/"} /> : <SignUp />} />
						<Route path="/share/:shareid" element={<SharedLinks />} />
						<Route path='*' element={<Navigate to={"/"} />} />
					</Routes>
				</BrowserRouter>
				<GlobalSnackbar />
			</>
		);
	}

	return (
		<>
			<MemoryRouter>
				<Routes>
					<Route path="/" element={isLoggedIn ? <Dashboard /> : loading ? <Loading /> : <ExtensionHomePage />} />
					<Route path="/signin" element={loading ? <Loading /> : isLoggedIn ? <Navigate to={"/"} /> : <SignIn />} />
					<Route path="/signup" element={loading ? <Loading /> : isLoggedIn ? <Navigate to={"/"} /> : <SignUp />} />
					<Route path='*' element={<Navigate to={"/"} />} />
				</Routes>
			</MemoryRouter>
			<GlobalSnackbar />
		</>
	);
}

export default App;
